
import http from "../util/http";

const modules = `sy`;

const modulesCt = "ct";

export default {
  productPage: data => http.get(`${modulesCt}/product/page`, data), // 产品
};